import { useMemo } from "react";
import { useFetchApi } from "../../hooks/useFetchApi";
import { PolicyDetails } from "shared";

export const usePolicy = (policyNumber: string) => {
  const { data: policy } = useMemo(
    () => useFetchApi<PolicyDetails>(`policy/${policyNumber}`, 2),
    []
  );

  return policy;
};
